export default "__VITE_ASSET__CRV9fEuM__"